
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Origem de dados',
	'dataSourceId': 'ID',
	'dataSourceType': 'Tipo',
	'dataSourceName': 'Nome',
	'dataSourcePath': 'Caminho',
	'showInfoForAll': 'Mostrar duração de todas as visualizações',
	'hideInfoForAll': 'Ocultar duração de todas as visualizações',
	'showPerformanceDetails': 'Executar novamente todos os widgets para incluir os detalhes de desempenho',
	'slotMappingField': 'Mapeamentos de Slot',
	'slotDataMapping': 'Mapeamento',
	'slotID': 'ID',
	'slotCaption': 'Texto Explicativo',
	'slotMandatory': 'Mandatório',
	'slotIsMandatory': 'Sim',
	'slotIsNotMandatory': 'Não',
	'infoNotAvailable': 'Indisponível',
	'performanceSection': 'Desempenho',
	'durationField': 'Duração',
	'singleQueryTime': 'Consulta de servidor (ms)',
	'multipleQueryTime': 'Consulta de servidor %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'Não disponível',
	'renderInProgress': '(em progresso)',
	'interactToTriggerQuery': 'Interagir com o widget para acionar uma consulta',
	'fetchQuery': 'Buscar consulta',
	'showSQLMDX': 'Mostrar SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informações sobre a Consulta',
	'queryInfoNotAvailable': 'As informações sobre a consulta não estão disponíveis',
	'query': 'Consulta',
	'copy': 'Copiar',
	'close': 'Fechar'
});
